import {ElLoading, ElMessage, ElMessageBox} from "element-plus";


export const confirmation = (message: string, title: string, confirmText: string, cancelText: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    ElMessageBox.confirm(
        message,
        title,
        {
          confirmButtonText: confirmText,
          cancelButtonText: cancelText,
        }
    ).then(() => {
      resolve();
    }).catch(() => {
      reject()
    })
  });
}

export const alertError= (message: string):void => {
    ElMessage.error(message);
}

export const alertErrorDialog = (
    message: string,
    title: string,
    confirmText: string,
    options: { customClass?: string; confirmButtonClass?: string } = {}
): Promise<void> => {
  return ElMessageBox.alert(message, title, {
    type: 'error',
    confirmButtonText: confirmText,
    customClass: options.customClass,
    confirmButtonClass: options.confirmButtonClass,
  }).then(() => undefined).catch(() => undefined);
}

export const loadingFullscreen=()=>{
  ElLoading.service({
    lock: true,
    text: '',
    background: 'rgba(255, 255, 255, 0.7)',
  })
}
